module.exports = __webpack_public_path__ + "static/fathersdayvest-f318603aad978eb7eaad98a236f4468b.jpeg";